import React from 'react';
import styles from './Alert.module.scss';
import cx from 'classnames';
import { Icon } from 'components';

type Props = {
  type: 'info' | 'error' | 'warning';
  size?: 'small' | 'normal';
  children: React.ReactNode;
};

export const Alert = ({ type, children, size = 'normal' }: Props) => {
  return (
    <div className={cx(styles.container, styles[type], styles[size])}>
      <Icon name="Info" />
      <div className={styles.content}>{children}</div>
    </div>
  );
};
